module.exports = __webpack_public_path__ + "static/media/mac.b175e1ee.png";